import { Stack } from "@mui/material";
import { TextSkeleton } from "@src/appV2/redesign/system/ui-components";

export function AddRolesLoadingState() {
  return (
    <Stack sx={{ flexDirection: "column", gap: 7, paddingY: 5 }}>
      {Array.from({ length: 12 }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <TextSkeleton key={index} variant="h6" sx={{ marginY: 4, marginLeft: 3 }} />
      ))}
    </Stack>
  );
}
